import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesCampaignCreatePage from '../../views/dashboard-voice-sales/CampaignCreatePage';

export const Route = createFileRoute('/dashboard/voice-sales/campaigns_/new')({
  component: VoiceSalesCampaignCreatePage,
});
